var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"history"}},[_c('div',{staticClass:"nav"},[_c('router-link',{attrs:{"to":"/historybrowse"}},[_vm._v("浏览历史")]),_c('router-link',{attrs:{"to":"/historydown"}},[_vm._v("下载历史")])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }